import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS } from "../i18n";

export function useLangPath() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (path) => (SUPPORTED_LANGS.includes(lang) ? `/${lang}${path}` : path);
}
